import {getInitData} from "./helper/getInitData";

export function* read(transactionType, originType, originTransaction = {}) {
    // Init Data
    const initData = yield getInitData(transactionType);

    return {
        ...originTransaction,

        // if no transaction fee, use system default
        account2_id: originTransaction.account2_id || initData.account2_id,

        // if myinvois_action is null, default to 'NORMAL'
        myinvois_action: originTransaction.myinvois_action || initData.myinvois_action,
    };
}
